import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const PlusIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Expand</title>
    <polygon points="48 17.14 30.86 17.14 30.86 0 17.14 0 17.14 17.14 0 17.14 0 30.86 17.14 30.86 17.14 48 30.86 48 30.86 30.86 48 30.86 48 17.14" />
  </IconBase>
);
